function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaygroundDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.02 48.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18,22a2,2,0,0,1,2-2h8a2,2,0,0,1,0,4H20A2,2,0,0,1,18,22ZM48,36v2A10,10,0,0,1,38,48H10A10,10,0,0,1,0,38V36a10,10,0,0,1,8-9.8V24a16,16,0,0,1,8-13.86A.66.66,0,0,1,16,10V8A8,8,0,1,1,32,8v2c0,.06,0,.1,0,.15A16,16,0,0,1,40,24v2.2A10,10,0,0,1,48,36ZM20,8.53a15.5,15.5,0,0,1,8,0V8a4,4,0,0,0-8,0ZM12,33.08a16.74,16.74,0,0,1,23.68-.33l.33.33V24a12,12,0,1,0-24,0ZM10,44h.06A9.88,9.88,0,0,1,8,38V30.38A6,6,0,0,0,4,36v2A6,6,0,0,0,10,44Zm20,0a6,6,0,0,0,5.75-4.37,12.87,12.87,0,0,0-23.5,0A6,6,0,0,0,18,44Zm14-8a6,6,0,0,0-4-5.63V38a9.87,9.87,0,0,1-2,6h0a6,6,0,0,0,6-6Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaygroundDefault);
export default __webpack_public_path__ + "static/media/playground-default.a5613d7a.svg";
export { ForwardRef as ReactComponent };